import {IImage} from './common.types';

export interface IBannerAction {
    displayName?: string;
    buttonId?: string;
    buttonType: string;
    label: string;
    mobileButtonLabel?: string;
    action: (buttonProps?: Record<string, any>) => void;
    navigationLink?: string;
}

export interface IRotatingBannerContent {
    key: string;
    value: '';
}

export interface IVideo {
    default: string;
    mobile: string;
}
export interface IBannerSlide {
    id: number;
    orgIndex: number;
    title: string;
    tier: string;
    showPrice: boolean;
    logo: string;
    lableType: string;
    label: string;
    offerLabel: string;
    showOfferLabel: boolean;
    description: string;
    backgroundImage: IImage;
    bannerType: string;
    actions: IBannerAction[];
    price?: string;
    entitlementSetId?: string;
    billingPeriod?: string;
    disable: boolean;
    index: number;
    hideFieldsInMobile: string[];
    disclaimer?: string;
    showCountDownTimer: boolean;
    hideCountdownZero: boolean;
    countdownVariant: 'V1' | 'V2';
    countdownTime: string;
    countdownUnits: string;
    videoUrl: IVideo;
    backgroundType: 'image' | 'video' | 'none';
    videoPosterImage?: IImage;
    isVideoTagSpecific: boolean;
    videoTags?: string[];
    rotatingContentItem: IRotatingBannerContent[];
    goldenLabel?: string;
    mobileBannerDesignType: MobileBannerDesignTypes;
}

export interface IBannerSlider {
    banners: IBannerSlide[];
    componentType: string;
}

export enum MobileBannerDesignTypes {
    CARD_TYPE = 'Card',
    FULL_SCREEN_TYPE = 'Fullscreen'
}
